import { isSupabaseConfigured, supabase } from "./supabase";
import { Platform } from "react-native";

export const getEmailConfirmRedirectUrl = () => {
  if (Platform.OS === "web" && typeof window !== "undefined") {
    return `${window.location.origin}/auth/callback`;
  }

  return "gakumonlensapp://auth/callback";
};

const readAuthParams = (url: string) => {
  const params = new URLSearchParams();

  const queryString = url.includes("?") ? url.split("?").at(-1)?.split("#")[0] ?? "" : "";
  const hashString = url.includes("#") ? url.split("#").at(-1) ?? "" : "";

  for (const source of [queryString, hashString]) {
    for (const [key, value] of new URLSearchParams(source)) {
      params.set(key, value);
    }
  }

  return {
    accessToken: params.get("access_token"),
    code: params.get("code"),
    refreshToken: params.get("refresh_token"),
    error: params.get("error_description") ?? params.get("error"),
  };
};

export const handleSupabaseAuthRedirect = async (
  url: string | null,
  onSessionRestored?: () => Promise<void>,
) => {
  if (!url || !isSupabaseConfigured) return false;

  const { accessToken, code, refreshToken, error } = readAuthParams(url);
  if (error) {
    console.warn("Supabase auth redirect failed", error);
    return false;
  }

  if (code) {
    const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);

    if (exchangeError) {
      console.warn("Failed to exchange Supabase auth code", exchangeError);
      return false;
    }

    await onSessionRestored?.();
    return true;
  }

  if (!accessToken || !refreshToken) return false;

  const { error: sessionError } = await supabase.auth.setSession({
    access_token: accessToken,
    refresh_token: refreshToken,
  });

  if (sessionError) {
    console.warn("Failed to restore Supabase session", sessionError);
    return false;
  }

  await onSessionRestored?.();
  return true;
};
